import { Avatar, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  hrmsEmployeeSearch: {
    cursor: "pointer",
    margin: "5px 0px",
    display: "flex",
  },
  hrmsEmployeeSearchContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  hrmsEmployeeSearchAvtar: {
    width: 25,
    height: 25,
    marginRight: "10px",
  },
}));

const EmployeeSearchCard = ({ highlightText, item }) => {
  const navigate = useNavigate();

  const classes = useStyle();

  const handleRedirect = () => {
    navigate(`employee/${item.id}/details`);
    localStorage.setItem("employee-view", "Employee-details");
    localStorage.setItem("activeMenuItem", "emplyoee-details");
  };
  return (
    <>
      <div className={classes.hrmsEmployeeSearchContainer}>
        <Grid className={classes.hrmsEmployeeSearch} onClick={handleRedirect}>
          <Avatar
            alt="profile user"
            src={item.image}
            className={classes.hrmsEmployeeSearchAvtar}
          />
          {highlightText(item.first_name)} {highlightText(item.last_name)}
        </Grid>
        <Typography>{highlightText(item.email)}</Typography>
      </div>
    </>
  );
};

export default EmployeeSearchCard;
